module.exports = __webpack_public_path__ + "img/abtrip.5a943fd0.png";